import React from "react";
import {UcFirst} from "Functions";
import IconButton from "Components/UI/IconButton";
import ImageField from "Components/UI/Field/ImageField";
import LoadImage from "Components/Layout/LoadImage";
import SelectField from "Components/UI/Field/SelectField";
import Spinner from "Components/Feedback/Spinner";

class WysiwygImageBlock extends React.Component
{
    constructor(props)
    {
        super(props);
        this.BlockUpdate = false;
        this.Controls = true;
        // Read only.
        this.Container = false;
        this.Image = false;
        this.Wrapper = false;
        this.state = {
            align: "fill",
            direction: "column",
            error: false,
            focusField: false,
            interaction: false,
            loading: false,
            size: 1,
            sizeMode: "fill",
            src: "",
            valign: "center"
        }
    }

    componentDidMount()
    {
        const {block, blockProps: {contentDirection, wrapper}, contentState} = this.props;
        const {
            align = "fill",
            sizeMode = "fill",
            src,
            valign = "center"
        } = contentState.getEntity(block.getEntityAt(0)).getData();
        this.Wrapper = wrapper;
        this.setState({
            align,
            direction: contentDirection,
            loading: true,
            sizeMode,
            src,
            valign
        });
        window.addEventListener("resize", this.OnResize);
    }

    componentDidUpdate()
    {
        if (this.BlockUpdate)
        {
            return;
        }
        const {block, blockProps: {contentDirection: d1, wrapper}, contentState} = this.props;
        const {direction: d2} = this.state;
        const {
            align: currentAlign,
            sizeMode: currentSizeMode,
            src: currentSrc,
            valign: currentValign
        } = this.state;
        const {
            align,
            sizeMode,
            src,
            valign
        } = contentState.getEntity(block.getEntityAt(0)).getData();
        this.Wrapper = wrapper;
        if (align !== currentAlign || sizeMode !== currentSizeMode || src !== currentSrc || valign !== currentValign || d1 !== d2)
        {
            this.setState({
                align,
                direction: d1,
                error: false,
                loading: src !== currentSrc,
                sizeMode,
                src,
                valign
            });
        }
        else
        {
            this.UpdateImageSize();
        }
    }

    componentWillUnmount()
    {
        window.removeEventListener("resize", this.OnResize);
    }

    Block = (e) =>
    {
        e.stopPropagation();
        e.preventDefault();
    }

    OnBlurField = () =>
    {
        this.setState({focusField: false});
    }

    OnChangeImage = (e, image) =>
    {
        const {block, blockProps = {}, contentState} = this.props;
        const {onChange = () => {}} = blockProps;
        const src = Array.isArray(image) ? image[0] : false
        onChange(block, contentState, src);
        this.setState({error: false, loading: true, src});
    }

    OnDelete = () =>
    {
        const {block, blockProps = {}, contentState} = this.props;
        const {onDelete = () => {}} = blockProps;
        onDelete(block, contentState);
    }

    OnError = () =>
    {
        this.setState({error: true, loading: false});
    }

    OnFocusField = () =>
    {
        this.setState({focusField: true});
    }

    OnHandleEnd = (e) =>
    {
        const {interaction, sizeMode} = this.state;
        if (!interaction)
        {
            return;
        }
        e.stopPropagation();
        e.preventDefault();
        window.removeEventListener("mousemove", this.OnHandleMove);
        window.removeEventListener("mouseup", this.OnHandleEnd);
        document.removeEventListener("mouseleave", this.OnHandleEnd);
        this.setState({interaction: false, size: this.LastPercent}, () =>
        {
            const {block, blockProps = {}, contentState} = this.props;
            const {onResize = () => {}} = blockProps;
            onResize(block, contentState, sizeMode === "relative" ? this.LastPercent : this.LastSize);
            this.LastPercent = 0;
            this.LastSize = 0;
            this.BlockUpdate = false;
        });
    }

    OnHandleMove = (e) =>
    {
        const {Image, state} = this;
        const {interaction, size} = state;
        if (!interaction || !Image)
        {
            return;
        }
        const [originX, originY, width, height, directionX, directionY] = interaction;
        const {pageX, pageY} = e;
        const deltaX = directionX * (pageX - originX);
        const deltaY = directionY * (pageY - originY);
        const percentX = Math.max(0, size + deltaX / width);
        const percentY = Math.max(0, size + deltaY / height);
        const percent = Math.max(0.01, Math.min(percentX * Math.abs(directionX || 9999), percentY * Math.abs(directionY || 9999)));
        this.LastPercent = percent;
        this.LastSize = percent * width;
        Image.style.width = this.LastSize + "px";
    }

    OnHandleStart = (e, x, y) =>
    {
        if (e.button !== 0 || !this.Wrapper)
        {
            return;
        }
        const {width, height} = this.Wrapper.getBoundingClientRect();
        const {pageX, pageY} = e;
        window.addEventListener("mousemove", this.OnHandleMove);
        window.addEventListener("mouseup", this.OnHandleEnd);
        document.addEventListener("mouseleave", this.OnHandleEnd);
        this.BlockUpdate = true;
        this.setState({interaction: [pageX, pageY, width, height, x, y]});
    }

    OnHorizontalAlign = (e, align) =>
    {
        const {block, blockProps = {}, contentState} = this.props;
        const {onHorizontalAlign = () => {}} = blockProps;
        onHorizontalAlign(block, contentState, align);
        this.setState({align});
    }

    OnSizeMode = (e, sizeMode) =>
    {
        const {block, blockProps = {}, contentState} = this.props;
        const {onSizeMode = () => {}} = blockProps;
        onSizeMode(block, contentState, sizeMode, sizeMode === "absolute" ? this.Wrapper.offsetWidth : 1);
        this.setState({size: 1, sizeMode});
    }

    OnVerticalAlign = (e, valign) =>
    {
        const {block, blockProps = {}, contentState} = this.props;
        const {onVerticalAlign = () => {}} = blockProps;
        onVerticalAlign(block, contentState, valign);
        this.setState({valign});
    }

    OnLoad = () =>
    {
        this.setState({loading: false});
    }

    OnResize = () =>
    {
        this.UpdateImageSize();
    }

    UpdateImageSize = () =>
    {
        if (this.BlockUpdate || !this.Image || !this.Wrapper)
        {
            return;
        }
        const {block, contentState} = this.props;
        const {size: currentSize, interaction} = this.state;
        const {size, sizeMode} = contentState.getEntity(block.getEntityAt(0)).getData();
        if (sizeMode !== "relative" && sizeMode !== "absolute")
        {
            return;
        }
        const Percent = Math.min(1, (sizeMode === "relative" || size <= 0) ? size : size / this.Wrapper.offsetWidth);
        const Size = sizeMode === "relative" ? size * this.Wrapper.offsetWidth : size;
        this.Image.style.width = Size + "px";
        if (Percent !== currentSize)
        {
            this.BlockUpdate = true;
            this.setState({size: Percent}, () => this.BlockUpdate = false);
        }
    }

    render()
    {
        const {
            align,
            direction,
            interaction,
            focusField,
            loading,
            sizeMode = "fill",
            src,
            valign
        } = this.state;
        const AllowAlign = direction === "column";
        const CA = ["WysiwygImageBlock", `Direction${UcFirst(direction)}`, `SizeMode${UcFirst(sizeMode)}`];
        switch (align)
        {
            case "left":
                CA.push("AlignLeft");
                break;
            case "right":
                CA.push("AlignRight");
                break;
            default:
                CA.push("AlignFill");
        }
        switch (valign)
        {
            case "bottom":
                CA.push("AlignBottom");
                break;
            case "top":
                CA.push("AlignTop");
                break;
            default:
                CA.push("AlignCenter");
        }
        if (interaction || focusField)
        {
            CA.push("Interacting");
        }
        if (loading)
        {
            CA.push("Loading");
        }
        return (
            <div
                className={CA.join(" ")}
                onClick={this.Block}
                onMouseDown={this.Block}
                ref={container => this.Container = container}
            >
                {loading ? <Spinner className="WysiwygImageBlockSpinner"/> : ""}
                <LoadImage
                    autoAdjust={true}
                    className="WysiwygImageBlockImage"
                    onError={this.OnError}
                    onImageElement={image => this.Image = image}
                    onLoad={this.OnLoad}
                    src={src}
                    useElement={true}
                >
                    {this.Controls && (
                    <div className="WysiwygImageBlockHandles">
                        <div
                            className="WysiwygImageBlockHandle Top Left"
                            onMouseDown={e => this.OnHandleStart(e, -1, -1)}
                        />
                            <div
                                className="WysiwygImageBlockHandle Top Center"
                                onMouseDown={e => this.OnHandleStart(e, 0, -1)}
                            />
                            <div
                                className="WysiwygImageBlockHandle Top Right"
                                onMouseDown={e => this.OnHandleStart(e, 1, -1)}
                            />
                            <div
                                className="WysiwygImageBlockHandle Middle Left"
                                onMouseDown={e => this.OnHandleStart(e, -1, 0)}
                            />
                            <div
                                className="WysiwygImageBlockHandle Middle Right"
                                onMouseDown={e => this.OnHandleStart(e, 1, 0)}
                            />
                            <div
                                className="WysiwygImageBlockHandle Bottom Left"
                                onMouseDown={e => this.OnHandleStart(e, -1, 1)}
                            />
                            <div
                                className="WysiwygImageBlockHandle Bottom Center"
                                onMouseDown={e => this.OnHandleStart(e, 0, 1)}
                            />
                            <div
                                className="WysiwygImageBlockHandle Bottom Right"
                                onMouseDown={e => this.OnHandleStart(e, 1, 1)}
                            />
                        </div>
                    )}
                </LoadImage>
                {this.Controls && (
                    <div className="WysiwygImageBlockToolbarWrapper">
                        <div className="WysiwygImageBlockToolbar">
                            <div className="WysiwygImageBlockToolbarGroup">
                                <IconButton
                                    active={align === "left"}
                                    className="WysiwygImageBlockToolbarButton"
                                    feather="AlignLeft"
                                    id="left"
                                    onClick={this.OnHorizontalAlign}
                                />
                                <IconButton
                                    active={align !== "left" && align !== "right"}
                                    className="WysiwygImageBlockToolbarButton"
                                    feather={AllowAlign ? "AlignJustify" : "AlignCenter"}
                                    id="fill"
                                    onClick={this.OnHorizontalAlign}
                                />
                                <IconButton
                                    active={align === "right"}
                                    className="WysiwygImageBlockToolbarButton"
                                    feather="AlignRight"
                                    id="right"
                                    onClick={this.OnHorizontalAlign}
                                />
                            </div>
                            {AllowAlign && (
                                <div className="WysiwygImageBlockToolbarGroup RotateIcons">
                                    <IconButton
                                        active={valign === "top"}
                                        className="WysiwygImageBlockToolbarButton"
                                        feather="AlignLeft"
                                        id="top"
                                        onClick={this.OnVerticalAlign}
                                    />
                                    <IconButton
                                        active={valign !== "bottom" && valign !== "top"}
                                        className="WysiwygImageBlockToolbarButton"
                                        feather="AlignCenter"
                                        id="center"
                                        onClick={this.OnVerticalAlign}
                                    />
                                    <IconButton
                                        active={valign === "bottom"}
                                        className="WysiwygImageBlockToolbarButton"
                                        feather="AlignRight"
                                        id="bottom"
                                        onClick={this.OnVerticalAlign}
                                    />
                                </div>
                            )}
                            <div className="WysiwygImageBlockToolbarGroup">
                                <SelectField
                                    className="WywiwygToolbarSelectField"
                                    onBlur={this.OnBlurField}
                                    onChange={this.OnSizeMode}
                                    onFocus={this.OnFocusField}
                                    options={{
                                        fill: "Fill",
                                        auto: "Auto",
                                        relative: "Relative",
                                        absolute: "Absolute"
                                    }}
                                    value={sizeMode}
                                />
                            </div>
                            <div className="WysiwygImageBlockToolbarGroup">
                                <ImageField
                                    className="WysiwygImageBlockToolbarButton"
                                    onChange={this.OnChangeImage}
                                    returnImage={true}
                                    minimal={true}
                                />
                                <IconButton
                                    className="WysiwygImageBlockToolbarButton"
                                    feather="X"
                                    onClick={this.OnDelete}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default WysiwygImageBlock;